import { getGCLIDParameters } from 'domains/tracking/GCLIDtracking';
import { getUTMParameters } from 'domains/tracking/UTMTracking';
import { DirectSignupFilters } from '../context';
import { buildUrl } from 'utils/url';

const JOTFORM_FULL_REGISTRATION_FORM = 'https://forms.expressable.com/251055433478963';

export const getJotformRegistrationFormLink = (filters: DirectSignupFilters, leadId?: string) => {
  const state = filters.stateCode;
  const pid = filters.paymentMethod.type === 'insurance' ? filters.paymentMethod.insuranceData.entryId : '';
  const GClid = getGCLIDParameters();
  const UTMParams = getUTMParameters();

  const queryParams = {
    state,
    pid: pid,
    leadID: leadId,
    gclid: GClid?.gclidTracker,
    ...UTMParams,
  };

  return buildUrl(JOTFORM_FULL_REGISTRATION_FORM, queryParams);
};
